<template>
    <div class="col-12 mb-primary">
        <div class="card card-with-shadow border-0 h-100">
            <div class="card-header p-primary bg-transparent">
                <h5 class="card-title m-0">{{ $t('service_category_add') }}</h5>
            </div>
            <app-overlay-loader v-if="preloader"/>
            <div class="card-body">
                <form ref="form" data-url="/service/category/store" class="mb-0" :class="{'loading-opacity': preloader}" enctype="multipart">
                    
                    <div class="form-group row align-items-center">
                        <label class="col-md-2 mb-md-0">
                            {{ $t('name') }}
                        </label>
                        <app-input class="col-md-8"
                                   type="text"
                                   v-model="reqData.name"
                                   :required="true"
                                   :placeholder="$t('name')"/>
                    </div>
                    <div class="form-group row align-items-center">
                        <label class="col-md-2 mb-md-0">
                            {{ $t('status') }}
                        </label>
                            <app-input class="col-md-8 mt-2 pt-1"
                                       type="radio"
                                       :list="statusLists"
                                       v-model="reqData.status"
                                       :required="true"/>
                    </div>
                    <div class="mt-5 action-buttons">
                        <button type="submit" class="btn btn-primary mr-2" @click.prevent="submit">
                            {{ $t('submit')}}
                        </button>
                        <button type="submit" class="btn btn-secondary" @click.prevent="clear">
                            {{ $t('clear') }}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
    import {FormMixin} from "../../../../../../core/mixins/form/FormMixin"; 
    export default {
        name: "FormLayouts",
        mixins: [FormMixin],
        props: ['categories'],
        data() {
             return {
                preloader: false,
                reqData: {
                    pid: '',
                    name: '',
                    status: 'active',

                },
                statusLists: [
                    {id: 'active', value: "Active"},
                    {id: 'inactive', value: "Inactive"},
                ]
            }
        },
        methods: {
            beforeSubmit(){
                this.preloader = true;
            },
            submit() {
                let formData = new FormData;
                for (const [key, value] of Object.entries(this.reqData)) {
                    if (value != null) formData.append(key, value);
                }
                this.save(formData);
            },
            afterSuccess(res) {
                this.$toastr.s(res.data.message);
            },
            afterFinalResponse() {
                this.preloader = false;
                this.reqData = {
                    status: 'active',
                };
            },
            afterError(res) {
                console.log(res);
                this.$toastr.e(res.data.message);
            },
            clear() {
                this.reqData = {
                    status: 'active',
                };
                this.fieldStatus = {
                    isSubmit: false
                }
            },
        }

    }
</script>
